export type LabType = "wet" | "dry";

export type LabTypeValue = LabType | { type: LabType } | null | undefined;

export interface LabTypeOption {
  type: LabType;
}

export const normalizeLabType = (value: LabTypeValue, fallback: LabType = "wet"): LabType => {
  if (value === "wet" || value === "dry") {
    return value;
  }

  if (value && typeof value === "object" && "type" in value) {
    const nested = value.type;
    return nested === "dry" ? "dry" : "wet";
  }

  return fallback;
};

export interface LabSummary {
  id: string;
  name: string;
  type: LabType;
  member_count: number;
  total_fte: number;
  champion_email?: string;
  is_member?: boolean;
  is_champion?: boolean;
}
